import { Box } from "@chakra-ui/react";
import { FC, ReactNode } from "react";
interface AuthLayoutProps {
  children: ReactNode | ReactNode[];
}

const SettingsLayout: FC<AuthLayoutProps> = ({ children }) => {
  return (
    <Box mx="5">
      <Box
        display="flex"
        flexDir="column"
        mx="auto"
        maxW="2xl"
        p="10"
        bgColor="white"
        color="black"
        borderColor="#CCCCD4"
        borderWidth="2px"
        rounded="35px"
        my="10vh"
      >
        {children}
      </Box>
    </Box>
  );
};

export default SettingsLayout;
